/* eslint-disable quote-props */
/* eslint-disable max-len */
import _ from 'lodash';
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { questionSlotData } from '../../../models/FormSpecRegistry';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_018: Question = {
  id: 'pres-018-part-ecosystemes-forestiers',
  oldId: '32',
  title: 'Part de la superficie des écosystèmes forestiers',
  number: '3.2',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      autofill: (values: any, sectionPath: string) => {
        const v1 = parseFloat(_.get(values, questionSlotData(sectionPath, 'pres-017-superficie-ecosystemes-forestiers'))) || 0;
        const superficie = parseFloat(_.get(values, 'superficie')) || 1;
        return ((v1 / 100 / superficie) * 100).toFixed(2);
      },
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.PERCENTAGE,
    },
  ],
};

export const question_pres_018_v2: Question = question_pres_018;
export const question_pres_018_v3: Question = question_pres_018;
